// 3rd party
import { Directive } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[my-dt-footer]'
})
export class MyDTFooterDirective {

}



// WEBPACK FOOTER //
// ./src/app/shared/components/my-dt/my-dt-footer.directive.ts